var url = "6e5f3547f2b45596a22f9c20b800e3d5.gif";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;